module.exports = __webpack_public_path__ + "img/locations_layout3.ad1a57da.png";